import styled from "styled-components";

export const GradedBackgroundImage = styled.div<{src: string, gradientOpacity: number}>`
    display: flex;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,${props => props.gradientOpacity})), url("${props => props.src}");
    background-size: cover;
    border-radius: 10px;
`;